import { render, staticRenderFns } from "./SriChart.vue?vue&type=template&id=58765425&scoped=true"
import script from "./SriChart.vue?vue&type=script&lang=js"
export * from "./SriChart.vue?vue&type=script&lang=js"
import style0 from "./SriChart.vue?vue&type=style&index=0&id=58765425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58765425",
  null
  
)

export default component.exports